import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { DraftAction } from '@Redux/actions';
import DraftComponent from '@Components/draft/show/DraftComponent';
import { useParams } from 'react-router-dom';

const CreateDraft: React.FC<CreateDraftProps> = ({isLoading, loadDraft}) => {
  const params = useParams();
  const teamId = params.team_id;

  if (!teamId) {
    return <div>
      Team not found!
    </div>
  }
  React.useEffect(() => {
    loadDraft(teamId);
  }, []);

  if(isLoading){
    return <div className="loader"></div>
  }

  return <DraftComponent/>;
};

const mapStateToProps = (state: AppState) => ({
  isLoading: !state.draft.entity || state.draft.isLoading || state.myTeam.isLoading
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<DraftAction>(TYPES.Actions.Tool.DraftAction);
  return {
    loadDraft: (teamId: string) => dispatch(action.getByTeam(teamId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDraft);

type CreateDraftProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>